'use strict';

var _ = require('lodash');

/**
 * Chart Directive
 * @constructor
 */
var ChartDirective = function ChartDirective($document) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('../templates/chart.html'),
    link: function link(scope, element) {
      var loadingFinished = false;
      var chartPanel = element.find('.chart-panel');
      var chartDataMissing = element.find('.data-missing');
      var textMessage = chartDataMissing.find('.text-message');
      function isElementVisible() {
        return element.is(':visible');
      }
      scope.renderChart = function (data, selectionSize) {
        scope.isDataPresent = !_.isEmpty(data);
        scope.toggleVisibility(scope.isDataPresent);
        scope.setErrorMessage(data);
        loadingFinished = true;
        if (scope.isDataPresent && isElementVisible()) {
          scope.renderChartDataPresent(data, selectionSize);
        }
      };
      scope.toggleVisibility = function (dataPresent) {
        if (dataPresent) {
          chartDataMissing.hide();
          chartPanel.show();
        } else {
          chartPanel.hide();
          chartDataMissing.show();
        }
      };
      scope.hidePanels = function () {
        chartPanel.hide();
        chartDataMissing.hide();
      };
      scope.setErrorMessage = function (data, message) {
        var caption = '';
        if (message) {
          caption = message;
        } else if (data === undefined) {
          caption = 'Error retrieving data';
        } else if (_.isEmpty(data)) {
          caption = 'No data to display';
        }
        textMessage.text(caption);
      };
      scope.setLoadingMessage = function (message) {
        message = message || 'Loading';
        loadingFinished = false;
        _.delay(function () {
          if (!loadingFinished) {
            textMessage.text(message);
            scope.toggleVisibility(false);
          }
        }, 25);
      };
      element.on('$destroy', function () {
        $document.find('.d3-tip').css('opacity', 0);
      });
      scope.$watch(isElementVisible, function (isVisible) {
        if (isVisible && scope.data && scope.data.length) {
          scope.renderChart(scope.data);
        }
      });
    }
  };
};
ChartDirective.$inject = ['$document'];
module.exports = ChartDirective;